import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BookOpen, ListChecks, CalendarRange } from 'lucide-react';

/**
 * Segmented "Notes / Tasks / Planner" switch shown in the top header of every
 * module. All three live under the same Notes login; this only changes route.
 */
export const ModuleSwitch = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isTasks = pathname.startsWith('/notes/tasks');
  const isPlanner = pathname.startsWith('/notes/planner');
  const isNotes = !isTasks && !isPlanner;

  const seg = (active) =>
    `n-focus inline-flex items-center gap-1.5 rounded-[9px] px-2.5 py-1.5 text-[13px] font-semibold transition-colors sm:px-3 ${
      active
        ? 'bg-[var(--n-accent-bg)] text-[var(--n-ink)] shadow-[inset_0_0_0_1px_var(--n-accent)]'
        : 'text-[var(--n-muted)] hover:text-[var(--n-ink)]'
    }`;

  return (
    <div data-testid="module-switch"
      className="inline-flex items-center rounded-xl border border-[var(--n-border)] bg-[var(--n-surface)] p-0.5">
      <button type="button" data-testid="module-switch-notes" onClick={() => navigate('/notes')} className={seg(isNotes)}>
        <BookOpen size={15} /> <span className="hidden sm:inline">Notes</span>
      </button>
      <button type="button" data-testid="module-switch-tasks" onClick={() => navigate('/notes/tasks')} className={seg(isTasks)}>
        <ListChecks size={15} /> <span className="hidden sm:inline">Tasks</span>
      </button>
      <button type="button" data-testid="module-switch-planner" onClick={() => navigate('/notes/planner')} className={seg(isPlanner)}>
        <CalendarRange size={15} /> <span className="hidden sm:inline">Planner</span>
      </button>
    </div>
  );
};

export default ModuleSwitch;
